/**
 * @file
 * Simple helpers for the cmc theme.
 */

(function ($, Drupal, drupalSettings, once) {
  ("use strict");

  var support_format_webp = function () {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d')))
    {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    else
    {
      // very old browser like IE 8, canvas not supported
      return false;
    }
  }

  var restPaddingFlag = true;

  var screenSize = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1200,
  };

  var setVideoToggleButtonState = function (button, icon, isPlaying) {
    var $button = $(button);
    var $icon = $(icon);
    var label = isPlaying ? Drupal.t('Pause video') : Drupal.t('Play video');

    $button.attr('aria-label', label);
    $button.attr('aria-pressed', isPlaying ? 'true' : 'false');
    $icon.attr('aria-hidden', 'true');
  };

  var buildVideoToggleButton = function () {
    return '<button class="active" id="play_button" type="button" aria-label="' + Drupal.t('Pause video') + '" aria-pressed="true"><i class="fas fa-pause" aria-hidden="true"></i></button>';
  };

  var slickFocusableSelector = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, summary, audio[controls], video[controls], [contenteditable], [tabindex]';
  var slickOriginalTabindexAttribute = 'data-cmc-slick-original-tabindex';
  var slickMissingTabindexValue = '__cmc_no_tabindex__';

  var rememberTabindex = function ($element) {
    if (!$element.is('[' + slickOriginalTabindexAttribute + ']')) {
      var originalTabindex = $element.attr('tabindex');
      $element.attr(
        slickOriginalTabindexAttribute,
        typeof originalTabindex === 'undefined' ? slickMissingTabindexValue : originalTabindex
      );
    }
  };

  var restoreTabindex = function ($element) {
    var originalTabindex = $element.attr(slickOriginalTabindexAttribute);
    if (typeof originalTabindex === 'undefined') {
      return;
    }

    if (originalTabindex === slickMissingTabindexValue) {
      $element.removeAttr('tabindex');
    }
    else {
      $element.attr('tabindex', originalTabindex);
    }

    $element.removeAttr(slickOriginalTabindexAttribute);
  };

  var syncSlickSlideFocus = function (slider) {
    $(slider).find('.slick-slide').each(function () {
      var $slide = $(this);
      var $focusableElements = $slide.find(slickFocusableSelector);

      if ($slide.attr('aria-hidden') === 'true') {
        rememberTabindex($slide);
        $slide.attr('tabindex', '-1');

        $focusableElements.each(function () {
          var $focusableElement = $(this);
          rememberTabindex($focusableElement);
          $focusableElement.attr('tabindex', '-1');
        });
      }
      else {
        restoreTabindex($slide);

        $focusableElements.each(function () {
          restoreTabindex($(this));
        });
      }
    });
  };



  Drupal.behaviors.cmcAiaWrapper = {
    attach: function (context, settings) {
      once('cmc-aia-wrapper', '.aia.init-wrapper', context).forEach(function(el){
        $(el).parent().addClass('aia-wrapper');
      });
      once('cmcm-aia-wrapper', '.cmc_magazine.init-wrapper', context).forEach(function(el){
        $(el).parent().addClass('cmcm-wrapper');
      });
    }
  };

  Drupal.behaviors.cmcEventDays = {
    attach: function (context, settings) {
      if ($('.block-cmc-registration-block', context).length) {
        var scrollToRegistration = window.location.search.match(/registration/);
        if (scrollToRegistration) {
          setTimeout(function () {
            var top = $('.block-cmc-registration-block', context).offset().top - $('.header-main').outerHeight() - 100;
            if ($('.toolbar-bar').length) {
              top - parseInt($('.dialog-off-canvas-main-canvas').css('padding-top'));
            }
            $('html, body').animate({ scrollTop: top }, '500');
          }, 500);
        }
      }
      if ( $('#successModal', context).length) {
        $('#successModal', context).modal();
      }
      if ($('#event_days', context).length) {
        $('#event_days', context).find('input[type="checkbox"]').each(function () {
          var val = $(this).val();
          var days = Object.keys(drupalSettings.registered_event_days).length;

          if (days == 1) {
            $(this).hide()
          }
          $(this).next().find('.registered, .filled').remove();
          if (
            drupalSettings.registered_event_days_data[val] &&
            drupalSettings.registered_event_days_data[val].type == 'head_table'
          ) {
            $(this).attr('disabled', 'disabled');
            if (!!+drupalSettings.registered_event_days_data[val].waitlist) {
              $(this).next().append('<div class="wait-list">' + Drupal.t('You are on the Head Table Waitlist')+ '</div>');
            }
            else {
              $(this).next().append('<div class="wait-list">' + Drupal.t('You are registered for the Head Table')+ '</div>');
            }
          }
          else if (drupalSettings.registered_event_days[val]) {
            $(this).attr('disabled', 'disabled');
            if (!!+drupalSettings.registered_event_days_data[val].waitlist) {
              $(this).next().append('<div class="wait-list">' + Drupal.t('You are on the Waitlist')+ '</div>');
            }
            else {
              let label = Drupal.t('You are already registered for this event.');
              $(this).next().append(
                '<div class="registered">' + label + '</div>'
              );
            }
          }
          if (drupalSettings.filled_event_days[val] && !drupalSettings.registered_event_days[val]) {
            $(this).next().append(
              '<div class="filled">' + Drupal.t('This event is full')+ '</div>'
            )
            $(this).next().append('<div class="filled-text small">' + Drupal.t('This event is full for Dinner. If you would like to be added to the waitlist, fill out the form below')+ '</span>')
          }
          if (
            drupalSettings.registered_event_days_data[val] &&
            drupalSettings.registered_event_days_data[val].type == 'head_table'
          ) {
            let label = Drupal.t('Cancel Headtable Registration');
            if (!!+drupalSettings.registered_event_days_data[val].waitlist) {
              label = Drupal.t('Cancel Headtable Waitlist Registration');
            }
            if (!drupalSettings.registered_event_days_data[val].disable_cancelling) {
              $(this).next().append(
                '<a class="btn btn-outline-primary" href="/user/' + drupalSettings.user.uid + '?registration_day=' + val + '">' + label + '</a>'
              );
            }
          }
          else if (drupalSettings.registered_event_days[val]) {
            let label = Drupal.t('Cancel Registration');
            if (!!+drupalSettings.registered_event_days_data[val].waitlist) {
              label = Drupal.t('Cancel Waitlist Registration');
            }
            if (!drupalSettings.registered_event_days_data[val].disable_cancelling) {
              $(this).next().append(
                '<a class="btn btn-outline-primary" href="/user/' + drupalSettings.user.uid + '?registration_day=' + val + '">' + label + '</a>'
              );
            }
          }
          if (drupalSettings.registered_event_days_data[val] && drupalSettings.registered_event_days_data[val].disable_cancelling) {
            let label = drupalSettings.field_deadline_cancelling_msg || ('The deadline for cancelling your registration for this event has passed.' +
            ' (Please note that the deadline is 9 am Pacific time on the day of the event.) Please contact Athenaeum at ' +
            '<a target="_blank" href="mailto:athenaeum@cmc.edu">athenaeum@cmc.edu</a>' +
            ' if you need further assistance.');
            $(this).next().append(
              '<div class="registered">' + label + '</div>'
            );
          }
        })
      }
    }
  }

  Drupal.behaviors.cmcEmbeddedImg = {
    attach: function (context, settings) {
      if ($('.field--name-body img', context).length) {
        $('.field--name-body img', context).each(function () {
          var $body = $(this).closest('.field--name-body');

          var $img = $(this);
          $(window).on("resize", function () {
            $img.css('width', '');
            if ($img.width() > $body.width() * 0.8) {
              $img.css('width', '100%');
            }
            else {
              $img.css('width', '');
            }

          });
        })
      }
    }
  }

  Drupal.behaviors.cmcSlickA11y = {
    attach: function (context) {
      once('cmc-slick-a11y', '.slick__slider, .slick-slider', context).forEach(function (slider) {
        var sync = function () {
          syncSlickSlideFocus(slider);
        };

        $(slider).on('init.cmcSlickA11y reInit.cmcSlickA11y afterChange.cmcSlickA11y setPosition.cmcSlickA11y breakpoint.cmcSlickA11y', sync);
        sync();

        if (window.MutationObserver) {
          var observer = new MutationObserver(function (mutations) {
            var shouldSync = mutations.some(function (mutation) {
              return $(mutation.target).hasClass('slick-slide');
            });

            if (shouldSync) {
              sync();
            }
          });

          observer.observe(slider, {
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-hidden', 'class'],
          });
        }
      });
    }
  };


  Drupal.behaviors.cmcExposed = {
    attach: function (context, settings) {
      if ($('#views-exposed-form-ath-events-block-4', context).length) {
        var url = location.pathname;
        if (url == '/athenaeum/historical-archives') {
          url = '/athenaeum/past-semester-schedules';
        }
        $('#views-exposed-form-ath-events-block-4', context).attr('action', url);
      }
    }
  }

  Drupal.behaviors.cmcEventColumns = {
    attach: function (context, settings) {
      if ($('.view-display-id-block_5', context).length) {
        var count = $('.view-display-id-block_5', context).find('.views-row').length;
        if (count > 2) {
          $('.view-display-id-block_5', context).addClass('colums-3');
        }
        else {
          $('.view-display-id-block_5', context).addClass('colums-2');
        }
      }
    }
  }

  /**
   * Cmc Banner behaviours.
   */
  Drupal.behaviors.cmcBanner = {
    attach: function (context, settings) {

      $("[data-banner-src]", context).each(function () {
        var url = $(this).data('banner-src');
        var fileurl = url.split('/').pop();
        var filename = fileurl.replace(/\?.+$/, '');
        var ext = filename.split('.').pop();
        // For now panteon not support generation of webp on the fly.
        $(this).css('background-image', 'url("' + url + '")');
      });
    }
  }

  /**
   * Core/Misc behaviours.
   */
  Drupal.behaviors.cmcMisc = {
    attach: function (context, settings) {
      if (window.location.hash.match(/collapse\-/)) {
        setTimeout(function(){
          var $el = $(window.location.hash);
          if ($el.length) {

            $el.parents('.accordion-item').each(function() {
              var button = $(this).find('.accordion-title button');
              if (button.length && button.attr('aria-expanded') == 'false') {
                button.click();
              }
            });
            setTimeout(function(){
              var top = $el.offset().top - $('header').outerHeight() - 100;
              if ($('.toolbar-bar').length) {
                top - parseInt($('.dialog-off-canvas-main-canvas').css('padding-top'));
              }
              $('html, body').animate({
                scrollTop: top
              }, 400);
            }, 500);
          }
        }, 500);
      }
      $(once('cmc-on-show', '.collapse'))
      .on('show.bs.collapse', function (e) {
        var id = $(e.target).attr('id');
        history.pushState(null,null,'#' + id);
      });
      function setMenuPosition() {
        var offsetTop = $(".dialog-off-canvas-main-canvas").offset().top;
        $(".navbar-collapse").css("padding-top", offsetTop + "px");
        if ($(window).width() < 1024) {
          $(".form-inline.search-form").css("padding-top", offsetTop + "px");
        } else {
          $(".form-inline.search-form").css("padding-top", null);
        }

        $("header").css("top", offsetTop + "px");
        var headerHeight = $("header").outerHeight() - 16;
        if (headerHeight > 0) {
          $(".dialog-off-canvas-main-canvas").css(
            "padding-top",
            headerHeight + "px"
          );
        }
      }
      var resetPadding = function () {};
      if (Drupal.offCanvas && Drupal.offCanvas.resetPadding) {
        resetPadding = Drupal.offCanvas.resetPadding.bind({});
        if (restPaddingFlag) {
          Drupal.offCanvas.resetPadding = function () {
            resetPadding();
            setMenuPosition();
          };
          restPaddingFlag = false;
        }
      }

      if ($("header", context).length) {
        setTimeout(function () {
          setMenuPosition();
        }, 1000);
        $(window).on("scroll", function () {
          setTimeout(function () {
            var scroll = $(window).scrollTop();
            if (scroll) {
              $("body").addClass("scrolled");
            } else {
              $("body").addClass("remove");
            }
          }, 0);
        });
      }
      if ($(".navbar-collapse", context).length) {
        setMenuPosition();
        $(window).on("load resize orientationchange", function () {
          setMenuPosition();
        });
      }
      $('button[data-target="#navbarCollapse"]').click(function () {
        $(window).resize();
      });
      $(".search-icon-menu", context)
        .off()
        .on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          $(".search-form").addClass("d-flex");
          setTimeout(function () {
            $(".search-form").addClass("show");
          }, 100);
        });
      $(".close-mobile-menu", context).on("click", function (event) {
        event.preventDefault();
        $('button[data-target="#navbarCollapse"]').click();
      });
      $(".search-icon", context).on("click", function (event) {
        event.preventDefault();
        $(this).closest(".navbar.wrapper").addClass("overflow-hidden");
        $(".search-form").addClass("d-flex");
        setTimeout(function () {
          $(".search-form").addClass("show");
        }, 100);
      });
      $(".search-close", context).on("click", function () {
        $(".search-form").removeClass("show");
        var self = this;
        setTimeout(function () {
          $(".search-form").removeClass("d-flex");
          $(self).closest(".navbar.wrapper").removeClass("overflow-hidden");
        }, 100);
      });

      if ($(window).width() <= 991) {
        $("header .dropdown-menu > .dropdown-item.dropdown > a", context).on("click", function (e) {
          e.stopPropagation();
          e.preventDefault();
          var sibling = $(this).siblings('ul');
          if (sibling.hasClass('show')) {
            sibling.removeClass('show');
          } else {
            sibling.addClass('show');
          }
        });

        $("header .dropdown-menu > .dropdown-item.dropdown > span", context).on("click", function (e) {
          e.stopPropagation();
          e.preventDefault();
          var sibling = $(this).siblings('ul');
          if (sibling.hasClass('show')) {
            sibling.removeClass('show');
          } else {
            sibling.addClass('show');
          }
        });
      }

      $(once('dropdown-item-a', ".content-section .dropdown-item a.dropdown-toggle, .content-section .dropdown a.dropdown-toggle", context)).click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var section = $(this).outerWidth()-24;
        if ($(this).siblings(".dropdown-menu").length) {
          if ($(this).attr('href') == '') {
            setTimeout(function () {
              if ($(this).next(".dropdown-menu").hasClass("show")) {
                $(this).next(".dropdown-menu").removeClass("show");
                $(this).attr("aria-expanded", false);
              }
              else {
                $(this).next(".dropdown-menu").addClass("show");
                $(this).attr("aria-expanded", true);
              }
              if ($(this).closest('main').length) {
                var padding = parseInt($('.dialog-off-canvas-main-canvas').css('padding-top')) + parseInt($('body').css('padding-top'));
                var y = $(this)[0].getBoundingClientRect().top + window.pageYOffset - padding;
                //window.scrollTo({top: y, behavior: 'smooth'});
                return;
              }
              $(this)[0].scrollIntoView();
            }.bind(this), 50);
          } else {
            if (e.offsetX >= section) {
              setTimeout(function () {
                if ($(this).next(".dropdown-menu").hasClass("show")) {
                  $(this).next(".dropdown-menu").removeClass("show");
                  $(this).attr("aria-expanded", false);
                }
                else {
                  $(this).next(".dropdown-menu").addClass("show");
                  $(this).attr("aria-expanded", true);
                }
                if ($(this).closest('main').length) {
                  var padding = parseInt($('.dialog-off-canvas-main-canvas').css('padding-top')) + parseInt($('body').css('padding-top'));
                  var y = $(this)[0].getBoundingClientRect().top + window.pageYOffset - padding;
                  return;
                }
              }.bind(this), 50);
            } else {
              window.location.href = $(this).attr('href');
            }
          }
        }
      });

      if ($('[about="/403"] a[href="/user/login"]', context).length) {
        $('[about="/403"] a[href="/user/login"]', context).each(function () {
          var link = $(this);
          if (!location.pathname.match(/$\/403/)) {
            link.attr('href', link.attr('href') + '?destination=' + location.pathname);
          }
        })
      }
    },
  };

  Drupal.behaviors.cmcTableSorter = {
    attach: function (context, settings) {
      $("table", context).each(function () {
        var $table = $(this);
        if ($table.closest('#layout-builder-modal').length) {
          return;
        }
        $table.tablesorter({
          theme: "bootstrap"
        });
      });
    }
  };
  Drupal.behaviors.cmcMega = {
    attach: function (context, settings) {
      $(".we-mega-menu-ul", context).on("mouseleave", function () {
        $(this)
          .children(".we-mega-menu-li")
          .children("a")
          .removeClass("active");
        $(this).children(".we-mega-menu-li").removeClass("active");
      });
      var $menu = $(".we-mega-menu-ul > .we-mega-menu-li", context);
      $menu.each(function () {
        var pevElement;
        var container;
        var $submenu = $(this).children(".we-mega-menu-submenu");
        var key = 0;
        var $menu_li = $(this);

        $menu_li.children("a").on("mouseenter focus", function () {
          var link = $(this);
          $menu.children("a").removeClass("active");
          $menu.removeClass("active");
          link.addClass("active");
          link.parent().addClass("active");
        });
        $submenu.each(function () {
          var $inner = $(this).first(".we-mega-menu-submenu-inner");
          $submenu.find(".we-mega-menu-li[data-level='1']").each(function () {
            var $child = $(this).find(".we-mega-menu-submenu");
            if (!$child.find('[data-level="2"]').length) {
              if ($child.find('.subul').length && !$child.find('.subul li').length) {
                $child.find('.subul').closest('.we-mega-menu-col ').remove()
              }
              $child.removeClass('grid-container');
              $(this).addClass('no-items');
            }
            var $sub_menu_li = $(this);
            $sub_menu_li.children("a").on("mouseenter focus  ", function () {
              var link = $(this);
              $submenu
                .find(".we-mega-menu-li[data-level='1']")
                .children("a")
                .removeClass("active");
              link.addClass("active");
              if (pevElement) {
                pevElement.insertAfter(container);
              }
              $child.appendTo($inner);
              pevElement = $child;
              container = $(this);
            });
          });
          if (key == 0) {
            $($submenu.find(".we-mega-menu-li[data-level='1']")[0])
              .children("a")
              .trigger("mouseenter");
          }
          key++;
        });
      });
    },
  };
  Drupal.behaviors.cmcMenu = {
    attach: function (context, settings) {
      var cleanUpMenu = function (selector) {
        var menu = $(this);

        $(this).find(selector).each(function () {
          var parentMenuLink = $(this).closest('li').find('> a');
          var submenu = $(this).find('> ul');
          var linkWrapper = $('<li class="dropdown-item"></li>');
          linkWrapper.append(parentMenuLink.clone());
          var link = linkWrapper.find('a');
          link.removeClass('dropdown-toggle').removeClass('active').attr('data-toggle', null);
          submenu.prepend(linkWrapper);
          var text = link.text();
          link.text(Drupal.t('Explore') + ' ' + text);
          if (!link.attr('href') || link.attr('href') == '') {
            link.attr('href', '#');
          }
        });
      }

      $(once('init-mobile', 'main .block-menu', context)).each(function () {
        // Disable this part for Layout builder. To not produce issue with contextual links.
        if (drupalSettings.path && drupalSettings.path.currentPathIsAdmin) {
          return;
        }
        var menu = $(this);
        if (this.mobileMenuInited) {
          return;
        }
        var mobileMenu;
        var initMobileMenu = function () {
          mobileMenu = menu.clone(false).off().unbind().insertAfter(menu);
          mobileMenu.get(0).mobileMenuInited = true;
          mobileMenu.find('*').removeAttr('data-toggle');
          mobileMenu.find('.dropdown-menu').addClass('show');
          mobileMenu.find('h2').remove();
          mobileMenu.addClass('d-none');
          var nav = mobileMenu.find('.nav.navbar-nav').first();
          var wrapper = $('<div class="mobile-menu-wrapper"></div>');
          var button = $('<button class="mobile-menu-trigger btn btn-primary large">' + 'Choose a section' + '</button>');
          button.on('click', function () {
            setTimeout(function() {
              nav.toggleClass('expanded');
            }, 50);
            $(this).toggleClass('expanded');
            wrapper.toggleClass('expanded');
          });
          var layoutRow = mobileMenu.closest('.layout.row').children().first();
          wrapper.append(button).append(nav).appendTo(mobileMenu);
          if (layoutRow.length) {
            mobileMenu.prependTo(layoutRow);
          }
          window.dispatchEvent(new Event('resize'));
        }
        window.addEventListener('resize', function () {
          if (mobileMenu && window.innerWidth <= screenSize.lg) {
            mobileMenu.removeClass('d-none').addClass('d-block');
            menu.removeClass('d-block').addClass('d-none');
          }
          else {
            mobileMenu.removeClass('d-block').addClass('d-none');
            menu.removeClass('d-none').addClass('d-block');
          }
        })
        initMobileMenu();
        this.mobileMenuInited = true;
      });
      $('.menu-content .menu--main', context).each(function () {
        cleanUpMenu.call(this, '> ul > li > ul > li');
      });
      $('main .menu--main', context).each(function () {
        if ($(this).find('.mobile-menu-wrapper').length) {
          return;
        }
        cleanUpMenu.call(this, '> ul > li');
        cleanUpMenu.call(this, '> ul > li > ul > li');
      });
    }
  };



  Drupal.behaviors.cmcClamps = {
    attach: function (context, settings) {
      if ($('.athenaeum-section', context).length) {

        if (support_format_webp()) {
          $('.athenaeum-section', context).addClass('webp');
        }
        else {
          $('.athenaeum-section', context).addClass('no-webp');
        }
      }
      if ($(".card, .view-id-news", context).length) {
        $(".card, .view-id-news", context).each(function () {
          var read_less = $(this).find('.card-read-less');
          var read_more = $(this).find('.card-read-more');
          var body_text = $(this).find('.card-body-text');
          $(once('read-less', read_less)).on('click', function () {
            event.preventDefault();
            read_more.toggleClass('hide');
            body_text.toggleClass('hide');
          });
          $(once('read-more', read_more)).on('click', function () {
            event.preventDefault();
            $(this).toggleClass('hide');
            body_text.toggleClass('hide');
          });
          if ($(this).data('trim') == 'no-trim') {
            return;
          }
          if (
            $(this).attr("class").indexOf("bg-") !== -1 ||
            $(this).attr("class").indexOf("border-style-") !== -1
          ) {
            $(this).addClass("card-force-body-padding");
          }
          var title = $(this).find(
            ".card-title h3, .card-title h2, .card-title h1, .views-field-title a"
          )[0];
          var body = $(this).find(".card-text p, .card-text div.field--name-body p, .card-text div.field--name-body, .views-field-field-subtitle .field-content");
          if (body.length) {
            body = body[body.length - 1]
          }
          else {
            body = null;
          }
          if ($(this).hasClass("card-large")) {
            if (title && $(this).data('trim') != 'no-title-trim') {
              $clamp(title, { clamp: 3 });
            }
            if (body && $(this).data('trim') != 'no-body-trim') {
              $clamp(body, { clamp: 3 });
            }
          } else if (
            $(this).hasClass("card-medium") ||
            $(this).hasClass("card-small")
          ) {
            if (title && $(this).data('trim') != 'no-title-trim') {
              $clamp(title, { clamp: 2 });
            }
            if (body && $(this).data('trim') != 'no-body-trim') {
              $clamp(body, { clamp: 2 });
            }
          } else {
            if (title && $(this).data('trim') != 'no-title-trim') {
              $clamp(title, { clamp: 2 });
            }
            if (body && $(this).data('trim') != 'no-body-trim') {
              $clamp(body, { clamp: 3 });
            }
          }
        });
      }
    },
  };
  Drupal.behaviors.cmcTableResponsive  = {
    attach: function (context, settings) {
      if ($("table", context).length) {
        $("table", context).each(function () {
          if ($(this).closest('#layout-builder-modal').length) {
            return;
          }
          $(once('wrap', this)).wrap('<div class="table-responsive"></div>');
          var wrapper = $(this).parent();
          wrapper.wrap('<div class="table-responsive-shadow"></div>');
          var wrapperShadow = wrapper.parent();
          var checkScrollable = function () {
            if (wrapper.width() < $(this).width()) {
              wrapperShadow.addClass("scrollable");
              wrapper.addClass("scrollable");
            }
            else {
              wrapperShadow.removeClass("scrollable");
              wrapper.removeClass("scrollable");
            }
          }.bind(this);
          checkScrollable();
          $(window).resize(function () {
            checkScrollable();
          })
          wrapper.on("scroll", function () {
            if (wrapper.scrollLeft() != 0) {
              wrapper.addClass("scrolled");
              wrapperShadow.addClass("scrolled");
            } else {
              wrapper.removeClass("scrolled");
              wrapperShadow.removeClass("scrolled");
            }
            if (
              wrapper[0].scrollWidth - wrapper[0].scrollLeft ===
              wrapper[0].clientWidth
            ) {
              wrapper.addClass("end");
              wrapperShadow.addClass("end");
            } else {
              wrapper.removeClass("end");
              wrapperShadow.removeClass("end");
            }
          });
        });
      }
    }
  };

  Drupal.behaviors.cmcStylesThemesOverrides = {
    attach: function (context) {
      if($('.media-library-widget-modal').length) {
        $(document).ajaxComplete(function() {
          $('.media-library-widget-modal').addClass('ui-layout-builder-modal');
          $('.media-library-widget-modal .button').removeClass('button').removeClass('button--primary').removeClass('button--secondary');
        });
      }
    }
  };

  // for any Layout Builder Section with Video Background enabled
  Drupal.behaviors.cmcVideoBackgroundButton = {
    attach: function (context, settings) {
      $(window).on('load', function() {

        // find each ambient video instance
        $('.bg-video').each(function() {

          // add a pause button
          $(this).append(buildVideoToggleButton())

          // get video, button, and icon
          var video = $(this).find('video');
          var playButton = $(this).find('button');
          var playButtonIcon = $(playButton).find('i');
          setVideoToggleButtonState(playButton, playButtonIcon, true);

          // check video networkState
          // (fixes Pantheon hosted video playback autoplay issue on some devices)
          if ($(video)[0].networkState == 3) {  // If no HTMLMediaElement src found
            console.log('video networkState 3');
            $(video)[0].load(); // reload video from src
          }

          $(video)[0].onplay = function () {
            // Do play stuff here
            $(playButton).addClass("active");
            $(playButtonIcon).removeClass("fa-play");
            $(playButtonIcon).addClass("fa-pause");
            setVideoToggleButtonState(playButton, playButtonIcon, true);
          };

          $(video)[0].onpause = function () {
            // Do pause stuff here
            $(playButton).removeClass("active autoplay");
            $(playButtonIcon).removeClass("fa-pause");
            $(playButtonIcon).addClass("fa-play");
            setVideoToggleButtonState(playButton, playButtonIcon, false);
          };

          // check if autoplay starts or not
          var promise = $(video).get(0).play();

          if (promise !== undefined) {
            promise.then(_ => {
              // Autoplay started!
              // Do play stuff
              $(playButton).addClass("active autoplay");
              $(playButtonIcon).removeClass("fa-play");
              $(playButtonIcon).addClass("fa-pause");
              setVideoToggleButtonState(playButton, playButtonIcon, true);
            }).catch(error => {
              // Autoplay not allowed!
              // Do pause stuff here
              $(playButton).removeClass("active");
              $(playButtonIcon).removeClass("fa-pause");
              $(playButtonIcon).addClass("fa-play");
              setVideoToggleButtonState(playButton, playButtonIcon, false);
            });
          }

          // Play button play/pause behavior
          $(playButton).click(function(){
            if ($(playButton).hasClass("active")){
              video.get(0).pause();
            } else {
              video.get(0).play();
            }
          });

        });
      });
    }
  }

  Drupal.behaviors.cmcVideoButton = {
    attach: function (context, settings) {
      $(window).on('load', function() {

        // find each ambient video instance
        $('.ambient-video').each(function() {

          // get video, button, and icon
          var video = $(this).find('video');
          var playButton = $(this).find('button');
          var playButtonIcon = $(playButton).find('i');
          setVideoToggleButtonState(playButton, playButtonIcon, $(playButton).hasClass("active"));

          // check video networkState
          // (fixes Pantheon hosted video playback autoplay issue on some devices)
          if ($(video)[0].networkState == 3) {  // If no HTMLMediaElement src found
            console.log('video networkState 3');
            $(video)[0].load(); // reload video from src
          }

          $(video)[0].onplay = function () {
            // Do play stuff here
            $(playButton).addClass("active");
            $(playButtonIcon).removeClass("fa-play");
            $(playButtonIcon).addClass("fa-pause");
            setVideoToggleButtonState(playButton, playButtonIcon, true);
          };

          $(video)[0].onpause = function () {
            // Do pause stuff here
            $(playButton).removeClass("active autoplay");
            $(playButtonIcon).removeClass("fa-pause");
            $(playButtonIcon).addClass("fa-play");
            setVideoToggleButtonState(playButton, playButtonIcon, false);
          };

          // check if autoplay starts or not
          var promise = $(video).get(0).play();

          if (promise !== undefined) {
            promise.then(_ => {
              // Autoplay started!
              // Do play stuff
              $(playButton).addClass("active autoplay");
              $(playButtonIcon).removeClass("fa-play");
              $(playButtonIcon).addClass("fa-pause");
              setVideoToggleButtonState(playButton, playButtonIcon, true);
            }).catch(error => {
              // Autoplay not allowed!
              // Do pause stuff here
              $(playButton).removeClass("active");
              $(playButtonIcon).removeClass("fa-pause");
              $(playButtonIcon).addClass("fa-play");
              setVideoToggleButtonState(playButton, playButtonIcon, false);
            });
          }

          // Play button play/pause behavior
          $(playButton).click(function(){
            if ($(playButton).hasClass("active")){
              video.get(0).pause();
            } else {
              video.get(0).play();
            }
          });

        });
      });
    }
  }

  Drupal.behaviors.cmcVideoButton = {
    attach: function (context, settings) {
      $(window).on('load', function() {

        // find each ambient video instance
        $('.hero-video').each(function() {

          // get video, button, and icon
          var video = $(this).find('video');
          var playButton = $(this).find('button');
          var playButtonIcon = $(playButton).find('i');
          setVideoToggleButtonState(playButton, playButtonIcon, $(playButton).hasClass("active"));

          // check video networkState
          // (fixes Pantheon hosted video playback autoplay issue on some devices)
          if ($(video)[0].networkState == 3) {  // If no HTMLMediaElement src found
            console.log('video networkState 3');
            $(video)[0].load(); // reload video from src
          }

          $(video)[0].onplay = function () {
              // Do play stuff here
              $(playButton).addClass("active");
              $(playButtonIcon).removeClass("fa-play");
              $(playButtonIcon).addClass("fa-pause");
              setVideoToggleButtonState(playButton, playButtonIcon, true);
          };

          $(video)[0].onpause = function () {
              // Do pause stuff here
              $(playButton).removeClass("active autoplay");
              $(playButtonIcon).removeClass("fa-pause");
              $(playButtonIcon).addClass("fa-play");
              setVideoToggleButtonState(playButton, playButtonIcon, false);
          };

          // check if autoplay starts or not
          var promise = $(video).get(0).play();

          if (promise !== undefined) {
            promise.then(_ => {
              // Autoplay started!
              // Do play stuff
              $(playButton).addClass("active autoplay");
              $(playButtonIcon).removeClass("fa-play");
              $(playButtonIcon).addClass("fa-pause");
              setVideoToggleButtonState(playButton, playButtonIcon, true);
            }).catch(error => {
              // Autoplay not allowed!
              // Do pause stuff here
              $(playButton).removeClass("active");
              $(playButtonIcon).removeClass("fa-pause");
              $(playButtonIcon).addClass("fa-play");
              setVideoToggleButtonState(playButton, playButtonIcon, false);
            });
          }

          // Play button play/pause behavior
          $(playButton).click(function(){
            if ($(playButton).hasClass("active")){
              video.get(0).pause();
            } else {
              video.get(0).play();
            }
          });

        });
      });
    }
  }

  Drupal.behaviors.cmcVideoHeroTrigger = {
    attach: function (context) {
      $(document).ready(function(){
        //Examples of how to assign the Colorbox event to elements
        var videoId = $(".overlay-load").attr('data-video');
        var obj = {"video": {
          "value": "<iframe title='YouTube video player' type=\"text/html\" width='100%' height='100%' src='https://www.youtube.com/embed/"+videoId +"?autoplay=1' allow='autoplay; fullscreen' frameborder='0' allowFullScreen></iframe>"
        }};
        if (typeof videoId !== 'undefined' && videoId !== null) {
          $(".overlay-load").unbind().click(function () {
            $("#overlay-frame").show();
            $("#overlay-frame").prepend(obj.video.value);
          });
          $("#close_button").click(function () {
            $("#overlay-frame").hide();
            $("#overlay-frame iframe").remove();
          });
        }
      });
    }
  };

  Drupal.behaviors.cmcAlumniSearch = {
    attach: function (context, settings) {
      once('alumni-search', '.alumni-search', context).forEach(function (form) {
        var $form = $(form);
        var $input = $form.find('input[type="text"]');
        var $button = $form.find('button[type="submit"]');

        $button.on('click', function (e) {
          if (!$form.hasClass('open')) {
            e.preventDefault();
            $form.addClass('open');
            $input.focus();
          }
        });

        $(document).on('click.alumni-search', function (e) {
          if (!$(e.target).closest('.alumni-search').length) {
            $form.removeClass('open');
          }
        });
      });
    }
  }

  // dialog.ajax.js calls _focusTabbable() after every AJAX update inside the dialog,
  // scrolling the modal to the title input. Patch the instance to restore scrollTop after focus.
  Drupal.behaviors.cmcTabledragModalFix = {
    attach: function (context) {
      once('cmc-tabledrag-href', 'a.tabledrag-handle', context).forEach(function (el) {
        if (el.closest('#layout-builder-modal')) {
          el.setAttribute('href', 'javascript:void(0)');
        }
      });

      once('cmc-dialog-focus-fix', document.documentElement).forEach(function () {
        window.addEventListener('dialog:aftercreate', function (e) {
          if (!e.target || e.target.id !== 'layout-builder-modal') return;
          var modal = e.target;
          var inst = $(modal).data('ui-dialog');
          if (!inst) return;
          var orig = inst._focusTabbable.bind(inst);
          inst._focusTabbable = function () {
            var top = modal.scrollTop;
            orig();
            modal.scrollTop = top;
          };
        });
      });

      var modal = document.getElementById('layout-builder-modal');
      if (modal && !modal._cmcTabledragFixed) {
        modal._cmcTabledragFixed = true;
        modal.addEventListener('mousedown', function (e) {
          if (!e.target.closest('a.tabledrag-handle')) return;
          var savedScrollTop = modal.scrollTop;
          function restoreOnMouseup() {
            requestAnimationFrame(function () { modal.scrollTop = savedScrollTop; });
            document.removeEventListener('mouseup', restoreOnMouseup);
            document.removeEventListener('touchend', restoreOnMouseup);
          }
          document.addEventListener('mouseup', restoreOnMouseup);
          document.addEventListener('touchend', restoreOnMouseup);
        });
      }

      if (!Drupal.tableDrag || Drupal.tableDrag.prototype._cmcModalFixed) return;
      var origSetScroll = Drupal.tableDrag.prototype.setScroll;
      Drupal.tableDrag.prototype.setScroll = function (scrollAmount) {
        if (this.table && this.table.closest('#layout-builder-modal')) return;
        return origSetScroll.call(this, scrollAmount);
      };
      Drupal.tableDrag.prototype._cmcModalFixed = true;
    }
  };

  //ckeditor issue with focus inside UI Dialog modal.
  $.widget("ui.dialog", $.ui.dialog, {
    _allowInteraction: function (event) {
      if (this._super(event)) {
        return true;
      }

      if (event.target.ownerDocument != this.document[0]) {
        return true;
      }

      if ($(event.target).closest(".cke_dialog").length) {
        return true;
      }

      if ($(event.target).closest(".cke").length) {
        return true;
      }
    },
  });
})(jQuery, Drupal, drupalSettings, once);
